import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import PriceListSection from '../components/PriceListSection';
import ContactSection from '../components/ContactSection';

const HomePage: React.FC = () => {
  const location = useLocation();

  React.useEffect(() => {
    // Check if the page was refreshed
    const isRefreshed = sessionStorage.getItem('isRefreshed');
    
    // Always scroll to top on initial load if no hash
    if (!window.location.hash) {
      window.scrollTo(0, 0);
    }

    if (isRefreshed) {
      // If refreshed, remove the hash from URL
      window.history.replaceState(null, '', window.location.pathname);
      sessionStorage.removeItem('isRefreshed');
    } else {
      // Handle hash navigation if not a refresh
      const hash = window.location.hash;
      if (hash) {
        const section = document.querySelector(hash);
        if (section) {
          setTimeout(() => {
            section.scrollIntoView({ behavior: 'smooth' });
          }, 100);
        }
      }
    }

    // Set up beforeunload listener to track refresh
    const handleBeforeUnload = () => {
      sessionStorage.setItem('isRefreshed', 'true');
    };
    
    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [location]); // Add location to dependencies to react to hash changes

  return (
    <>
      <Helmet>
        <title>Pelyák Adél | Pedikűr és Manikűr</title>
        <meta name="description" content="Professzionális pedikűr és manikűr szolgáltatások Pelyák Adéltól. Időpontfoglalás online vagy telefonon. Két helyszínen is megtalál!" />
        <meta name="keywords" content="pedikűr, manikűr, körömápolás, lábápolás, szépségápolás, Budapest" />
        <meta property="og:title" content="Pelyák Adél | Pedikűr és Manikűr" />
        <meta property="og:description" content="Professzionális gyógyászati pedikűr és manikűr szolgáltatások Pelyák Adéltól. Időpontfoglalás online vagy telefonon." />
        <meta property="og:type" content="website" />
      </Helmet>
      <Header />
      <main>
        <HeroSection />
        <section id="about-section">
          <AboutSection />
        </section>
        <section id="pricelist-section">
          <PriceListSection />
        </section>
        <section id="contact-section">
          <ContactSection />
        </section>
      </main>
      <Footer />
    </>
  );
};

export default HomePage; 